module.exports = __webpack_public_path__ + "img/cc.8ec68713.png";